import * as a from '../../actions/action_types'

const INTIAL_STATE = {
    urlObject: '',
}

export default (state = INTIAL_STATE, action) => {
    if (state === undefined) {
        state = null;
    }
    if (state === undefined) {
        state = null;
    }
    switch (action.type) {
        case a.LOCAL_STORE_DATA: {
            return { ...state, payload: action.payload }
        }
        default:
            return state;
    }
}